





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';
import OperatingHours from '@/components/popups/info-popup/OperatingHours.vue';
import RestaurantInfo from '@/components/common/RestaurantInfo.vue';
import DirectionsLink from '@/components/common/DirectionsLink.vue';
import GoogleMap from '@/components/common/GoogleMap.vue';

@Component({
  components: {
    GoogleMap,
    DirectionsLink,
    RestaurantInfo,
    OperatingHours,
  },
})
export default class InfoPopup extends Vue {
  @Prop() private merchant!: MerchantDetailsModel;
}
